import Cookie from "js-cookie";

const getGoogleAnalyticsClientId = () => {
  const googleAnalyticsCookie = Cookie.get("_ga");

  if (googleAnalyticsCookie) {
    const [clientId] = googleAnalyticsCookie.match(/\d+\.\d+$/);

    return clientId;
  }

  return null;
};

export default getGoogleAnalyticsClientId;
